export default {
  state: {
    Status: true,
    isShow: false,
    url:''
  },
  getter: {
    Status: state => {
      return state.Status
    },
    isShow: state => {
      return state.isShow
    },
    url:state=>{
      return state.url
    }
  },
  mutations: {
    Status(state, Status) {
      state.Status = Status;
    },
    isShow(state, isShow) {
      state.isShow = isShow;
    },
    url(state, url) {
      state.url = url;
    }
  },
  action: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/status.js